export default {
  name: 'searchObjects',
  methods: {
    searchObjects(array, key, value) {
      for (let i = 0; i < array.length; i++) {
        if (array[i][key] === value) {
          return array[i];
        }
      }
      return null;
    },
  },
};
